import io from "socket.io-client";
import Vue from "vue";
import router from "../router/index";
import ApiService from "./ApiService";
import { StorageService, TokenService } from "./StorageService";

let socket = null;

const SocketService = {
  // Opens the session websocket and registers this browser under the logged-in user.
  connect() {
    if (socket) {
      return;
    }
    const user = StorageService.getUserData();
    if (!user) {
      return;
    }
    socket = io(ApiService.getSocketUrl(), {
      path: "/api-gateway/socket.io",
      transports: ["polling", "websocket"]
    });
    socket.on("connect", () => {
      socket.emit("REGISTER_SESSION", { userId: user.id });
    });
    socket.on("SESSION_TERMINATED", () => {
      Vue.notify({
        group: "app",
        type: "error",
        text: "Detectamos un inicio de sesión en otro dispositivo o ubicación. Por seguridad, cerramos esta sesión."
      });
      StorageService.clearStorage();
      ApiService.removeHeader();
      localStorage.setItem(
        "session-expiration-message",
        "Detectamos un inicio de sesión en otro dispositivo o ubicación. Por seguridad, cerramos esta sesión."
      );
      SocketService.disconnect();
      window.dispatchEvent(new Event("app:force-logout"));
      router.push({ path: "/login", query: { reason: "replaced" } });
    });
  },

  disconnect() {
    if (socket) {
      socket.disconnect();
      socket = null;
    }
  },

  // Fallback for when the tab was backgrounded and missed the SESSION_TERMINATED event:
  // re-checks the token as soon as the tab regains focus and lets the 401 interceptor react.
  async checkSession() {
    if (!TokenService.getToken() || !StorageService.getUserData()) {
      return;
    }
    try {
      await ApiService.get("/auth/validate");
    } catch (error) {
      // handled globally by the axios 401 interceptor
    }
  }
};

const revalidateIfVisible = () => {
  if (document.visibilityState === "visible") {
    SocketService.checkSession();
  }
};

document.addEventListener("visibilitychange", revalidateIfVisible);
window.addEventListener("focus", revalidateIfVisible);

// Keeps the socket in sync whenever the session is force-closed elsewhere (e.g. a 401 response).
window.addEventListener("app:force-logout", () => SocketService.disconnect());

export default SocketService;
